module.exports = __webpack_public_path__ + "media/images/admin/cropping-4x3-c9a9861e9a307bbbc3e7138b5da23406.webp";